import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../../helpers';

const selectors = {
  productImage: '[data-product-image]',
  mainCarousel: '[data-image-carousel]',
  thumbnailCarousel: '[data-thumbnail-carousel]',
};

/**
 * Product image gallery on the PDP
 *
 * @export
 * @class ProductImages
 */
export default class ProductImages {
  constructor(el) {
    this.mainCarousel = el.querySelector(selectors.mainCarousel);
    this._initCarousel();
  }

  /**
   * Initialize primary image carousel
   */
  _initCarousel() {
    this.mainCarousel = new Splide(this.mainCarousel, {
      perPage: 1,
      padding: {
        right: '15px',
      },
      gap: '8px',
      pagination: false,
      arrows: false,
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.sm]: {
          padding: {
            right: '104px',
          },
          gap: '16px',
        },
        [unitlessBreakpoints.md]: {
          destroy: true,
        },
      },
    });

    this.mainCarousel.mount();
  }
}
